import { useCallback } from 'react';

import { provider } from 'providers';
import { TOKEN_TYPE } from 'providers/constants/tokenNames';

import { EPaths } from 'router/const/paths';

import { API } from 'constants/api';
import { searchParamsNames } from 'constants/searchParamsNames';

/** Вернет функцию, при вызове которой произойдет редирект на  авторизацию */
export function useRedirectToAuth() {
    return useCallback(() => {
        const { clientAuthQuery, managerAuthQuery, redirectTo } = searchParamsNames;
        const userTypeByToken = provider.tokenName;
        const { href, pathname, search } = window.location;
        const returnTo = href;

        if (userTypeByToken === TOKEN_TYPE.MANAGER) {
            const { managerAuthExtraQuery, managerAuthExtraTokenQuery } = searchParamsNames;

            return window.location.assign(
                `${API.MANAGER_AUTH_URL}?${managerAuthQuery}=${returnTo}&${managerAuthExtraQuery}=${managerAuthExtraTokenQuery}`,
            );
        }

        if (userTypeByToken === TOKEN_TYPE.CLIENT) {
            return window.location.assign(`${API.CLIENT_AUTH_URL}?${clientAuthQuery}=${returnTo}`);
        }

        return window.location.assign(`/${EPaths.AUTH}?${redirectTo}=${pathname}${search}`);
    }, []);
}
